export default __webpack_public_path__ + "static/1default-522e0345a6314b30499a0ca102378e8e.png";